import Directory from '@src/quince-site-common/src/domains/Directory'
import classnames from 'classnames'
import Link from '../link'
import styles from './breadCrumb.module.scss'

interface BreadcrumbsProps {
  directory: Directory
  breadCrumbListClass?: string
}

const Breadcrumbs = ({ directory, breadCrumbListClass }: BreadcrumbsProps) => {
  return (
    <ol className={classnames(styles.breadCrumbList, breadCrumbListClass)}>
      {directory.paths.map((path, index) => {
        if (index === directory.paths.length - 1) {
          // Last path fragment
          const truncatedPathDisplayName =
            path.displayName.length > 38 ? path.displayName.slice(0, 35) + '...' : path.displayName
          return (
            <li className={styles.breadCrumbPage} key={path.route}>
              {' '}
              {truncatedPathDisplayName}
            </li>
          )
        }

        return (
          <li className={styles.breadCrumbPage} key={`${path.route}${index}`}>
            <Link className={classnames(styles.breadCrumbLink, styles.breadCrumbButton)} href={path.route}>
              {path.displayName}
            </Link>
            <span>/</span>
          </li>
        )
      })}
    </ol>
  )
}

export default Breadcrumbs
